import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederOblDto from '../Models/VeilederOblDto';
import { connect } from 'react-redux';
import { VeilederOblAppState } from '../Store';
import { toggleVilkar } from '../Store/Valg/Actions';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { BoksResultat } from '../Ids';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { Resultat } from '../Models/Resultat';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultOwnProps {
    resultat: Resultat;
    eventId: string | null;
}

type ResultatProps = MapStateToProps & MapDispatchToProps & ResultOwnProps;

class ResultatComponent extends React.PureComponent<ResultatProps> {
    constructor(props: ResultatProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }
    componentDidMount(): void {
        updateLiveMessage();
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
    }

    onVilkarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
    }

    render(): JSX.Element {
        const { resultat, visVilkar, epiContext, eventId } = this.props;

        const basislanAndel = resultat.basislanAndelKey;
        const basislanTekst = resultat.basislanTekstKey;
        const unntakTekst = resultat.unntakTekstKey;
        const narOverskrift = resultat.narOverskriftKey;
        const narTekst = resultat.narTekstKey;
        const skalViseVilkarKnap = !!contentResolver(epiContext, 'lenketekstVilkar');

        return (
            <div
                id={BoksResultat}
                className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine"
            >
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'basislanTittel')}
                        </h3>
                    </div>

                    <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                        <div className="c-veileder__resultat-tekst">
                            <span>{contentResolver(epiContext, basislanAndel)}</span>
                        </div>
                        {contentResolver(epiContext, basislanTekst)}
                    </div>
                </div>

                {resultat.hasUnntak && (
                    <div className="c-veileder__panel-row">
                        <div className="c-veileder__content c-veileder__content--header">
                            <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                                {contentResolver(epiContext, 'unntakTittel')}
                            </h3>
                        </div>
                        <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                            <div className="c-veileder__resultat-tekst">
                                <span>{contentResolver(epiContext, 'unntakAndel')}</span>
                            </div>
                            {unntakTekst !== undefined ? contentResolver(epiContext, unntakTekst) : null}
                        </div>
                    </div>
                )}

                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'narTittel')}
                        </h3>
                    </div>

                    <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                        <div className="c-veileder__resultat-tekst-overskrift">
                            <span>{contentResolver(epiContext, narOverskrift)}</span>
                        </div>
                        {contentResolver(epiContext, narTekst)}
                    </div>
                </div>
                {skalViseVilkarKnap &&(
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--footer">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                            {contentResolver(epiContext, 'lenketekstVilkar')}
                        </button>
                        <ModalCompontent
                            isOpen={visVilkar}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText="modalVilkarAriaLabel"
                            eventId={eventId}
                            >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'modalVilkarTittel', 2)}
                                contentinnhold={contentResolver(epiContext, 'modalVilkarContent', 2)}
                                />
                        </ModalCompontent>
                    </div>
                </div>   
                )}
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederOblDto>;
    visVilkar: boolean;
}

interface MapDispatchToProps {
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederOblAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visVilkar: state.valg.visVilkar,
        };
    },
    { toggleVilkar, updateZIndex },
)(ResultatComponent);
